const { gtag } = require("ga-gtag");

const analitiks = (eventId: string, params: {} = {}): void => {
  //@ts-expect-error y-metrics
  if (typeof window.ym !== "function") return;
  //@ts-expect-error y-metrics
  window.ym("reachGoal", eventId, params);
  gtag("event", eventId, params);
};

export default analitiks;
